<template>


  <div class="row" style="height: 75vh; overflow-y: scroll;">

      <!-- brands -->
      <Block>
        <Title plus @plus="showAdd = true">{{meta[`brand/title`] || 'Brands'}}
          <template #desc>Custom attributes for {{ cat.title }}. This attributes will be show user when he will add the asset.</template>
          <template #more>
            <div class="row ch w200" style="margin-left: 20px; margin-top: 4px;">
              <input style="padding: 3px 12px; font-size: 13px; width: 100%;" type="text"  @input="brandSearch" placeholder="Search...">
            </div>


          </template>
        </Title>

        <div class="column" style="height: 80vh; overflow-y: scroll;">
        <table v-if="brands && brands.length">

            <tr class="bold">
              <td>ID</td>
              <td>Logo</td>
              <td class="fit">Active</td>
              <td>GPT</td>
              <td>Title</td>
              <td>Models</td>
              <td></td>
              <!-- <td></td> -->
            </tr>

          <tbody>
            <tr v-for="(item, index) in brands" :key="index" class="hover" :class="{active: brand ? item.id == brand.id :  false}">
              <!-- <td><input type="checkbox" ></td> -->
              <td class="t2">{{ item.id }}</td>
              <td class="cc" style="text-align: center;"  @click="uploadItem = item" v-upload.images="upload">
                <div class="column center">
                  <img v-if="item.image" :src="item.image" style="max-height: 20px; max-width: 20px;">
                  <div title="Upload brand logo" v-if="!item.image"><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2093 12.0118C18.2093 12.6599 18.0459 13.1661 17.7191 13.5304C17.3977 13.9 16.8887 14.0848 16.1923 14.0848H2.27415C1.69557 14.0848 1.26967 13.9241 0.996447 13.6027C0.728585 13.2866 0.567868 12.7912 0.514295 12.1163L3.55185 9.32823C3.71257 9.1729 3.87597 9.05773 4.04204 8.98274C4.21347 8.90775 4.39562 8.87026 4.58848 8.87026C4.7867 8.87026 4.9742 8.91043 5.15099 8.99078C5.33314 9.07113 5.50993 9.18629 5.68136 9.33627L7.1921 10.7263L10.8484 7.45616C11.0413 7.29011 11.2368 7.16423 11.435 7.07853C11.6333 6.99283 11.8449 6.94998 12.0699 6.94998C12.3056 6.94998 12.5252 6.99551 12.7288 7.08657C12.9377 7.17227 13.136 7.30082 13.3235 7.47223L18.2093 12.0118ZM5.90636 7.39188C5.55814 7.39188 5.23939 7.30886 4.95009 7.14281C4.66616 6.9714 4.43848 6.74108 4.26705 6.45183C4.09561 6.16258 4.0099 5.84387 4.0099 5.4957C4.0099 5.15289 4.09561 4.83686 4.26705 4.54761C4.43848 4.25837 4.66616 4.02804 4.95009 3.85663C5.23939 3.68523 5.55814 3.59953 5.90636 3.59953C6.25458 3.59953 6.57066 3.68523 6.85459 3.85663C7.13853 4.02804 7.36621 4.25837 7.53764 4.54761C7.70907 4.83686 7.79479 5.15289 7.79479 5.4957C7.79479 5.84387 7.70907 6.16258 7.53764 6.45183C7.36621 6.74108 7.13853 6.9714 6.85459 7.14281C6.57066 7.30886 6.25458 7.39188 5.90636 7.39188ZM2.36254 14.5427C1.58039 14.5427 0.99109 14.3445 0.594654 13.9482C0.198218 13.5571 0 12.976 0 12.2046V2.34612C0 1.56944 0.198218 0.985584 0.594654 0.594564C0.99109 0.198188 1.58039 0 2.36254 0H16.4494C17.2369 0 17.8289 0.200866 18.2253 0.602599C18.6218 0.998975 18.82 1.58015 18.82 2.34612V12.2046C18.82 12.976 18.6218 13.5571 18.2253 13.9482C17.8289 14.3445 17.2369 14.5427 16.4494 14.5427H2.36254ZM2.38665 13.5545H16.4333C16.878 13.5545 17.2209 13.4366 17.4619 13.2009C17.703 12.9653 17.8236 12.6144 17.8236 12.1484V2.40236C17.8236 1.93635 17.703 1.58551 17.4619 1.34982C17.2209 1.10878 16.878 0.988263 16.4333 0.988263H2.38665C1.93129 0.988263 1.58307 1.10878 1.34199 1.34982C1.10627 1.58551 0.988412 1.93635 0.988412 2.40236V12.1484C0.988412 12.6144 1.10627 12.9653 1.34199 13.2009C1.58307 13.4366 1.93129 13.5545 2.38665 13.5545Z" fill="var(--g1)"/></svg></div>
                </div>
                <!-- <div v-if="item.image" class="column center" :style="{background: `url(${item.image}) no-repeat center center`}" style="width: 30px;height: 30px; margin: 0px; background-color: 'white'; border-radius: 10px; background-size: contain;" ></div>  -->
                <!-- <div v-if="!item.image" class="column center" style="width: 30px;height: 30px; margin: 0px; background-color: var(--g05); border-radius: 10px; background-size: contain;" ></div>  -->
              </td>

              <td class="cc"><Check small v-model="item.active" @update="dict.update(item.id, 'active', item.active)"/></td>
              <td class="cc"><Check small v-model="item.gpt" @update="dict.update(item.id, 'gpt', item.gpt)"/></td>

              <!-- <td>{{ tools.ago(item.created) }}</td> -->
              <!-- <td>{{ item.title }}</td>               -->
              <!-- <td class="cc"><Switch small v-model="item.active" @update="updateSub(item.id, 'active', item.active)"/></td> -->
              <!-- <td @click="brand = item">{{ item.title }}</td> -->
              <td><input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="tableInput" placeholder="title..." type="text" v-model="item.title" @blur="dict.update(item.id, 'title', item.title)"></td>
              <!-- <td class="w300"><input class="tableInput" placeholder="short desc..." type="text" v-model="item.comment" @blur="updateBrand(item.id, 'comment', item.comment)"></td> -->

              <!-- <td>{{ item.sid }}</td>               -->
              <td @click="setBrand(item)" class="cc t2">{{item.meta.models || '...'  }}</td>
              <!-- <td class="hover"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.82872 14.6947C7.74154 14.6947 7.65666 14.6924 7.57407 14.6878C7.49148 14.6878 7.40889 14.6832 7.3263 14.674L6.94777 15.3967C6.90648 15.4793 6.84683 15.5389 6.76883 15.5756C6.69083 15.6169 6.60365 15.6284 6.50729 15.6101C6.41553 15.5917 6.33982 15.5504 6.28017 15.4862C6.22511 15.4219 6.18841 15.3416 6.17006 15.2453L6.04617 14.4538C5.88558 14.4079 5.72729 14.3552 5.57128 14.2955C5.41987 14.2405 5.26616 14.1808 5.11016 14.1166L4.52515 14.6396C4.45174 14.7039 4.37145 14.7429 4.28427 14.7566C4.19709 14.7704 4.10533 14.752 4.00897 14.7016C3.93097 14.6557 3.87591 14.5915 3.84379 14.5089C3.81626 14.4263 3.81167 14.3368 3.83003 14.2405L3.98144 13.4627C3.85297 13.3664 3.7245 13.2654 3.59603 13.1599C3.46755 13.0544 3.34367 12.9443 3.22437 12.8296L2.50172 13.1324C2.40536 13.1737 2.3136 13.1829 2.22642 13.1599C2.13924 13.137 2.06124 13.0842 1.99242 13.0016C1.93736 12.9328 1.90524 12.8548 1.89606 12.7676C1.89148 12.6758 1.91442 12.5887 1.96489 12.5061L2.38472 11.8247C2.29295 11.6917 2.20577 11.554 2.12318 11.4118C2.04518 11.2649 1.96718 11.1158 1.88918 10.9644L1.09082 10.9919C0.999054 11.0011 0.91417 10.9828 0.836169 10.9369C0.758168 10.8864 0.705403 10.813 0.677873 10.7166C0.645755 10.6249 0.643461 10.5377 0.670991 10.4551C0.698521 10.3725 0.748992 10.3014 0.822405 10.2418L1.44182 9.74623C1.40053 9.58564 1.36612 9.42505 1.33859 9.26446C1.31106 9.09928 1.2927 8.92951 1.28353 8.75515L0.519577 8.51427C0.423223 8.48674 0.349811 8.43856 0.29934 8.36974C0.248868 8.29633 0.223633 8.21144 0.223633 8.11509C0.223633 8.01415 0.248868 7.92926 0.29934 7.86044C0.349811 7.79161 0.423223 7.74344 0.519577 7.71591L1.28353 7.47502C1.2927 7.30067 1.31106 7.13319 1.33859 6.9726C1.36612 6.80743 1.40053 6.64454 1.44182 6.48395L0.822405 5.98153C0.748992 5.92647 0.698521 5.85765 0.670991 5.77506C0.643461 5.69247 0.645755 5.60759 0.677873 5.52041C0.705403 5.42406 0.758168 5.35294 0.836169 5.30706C0.91417 5.25658 0.999054 5.23594 1.09082 5.24511L1.88918 5.26576C1.96718 5.11435 2.04518 4.96752 2.12318 4.82529C2.20577 4.68305 2.29295 4.54081 2.38472 4.39857L1.95801 3.71721C1.91212 3.63921 1.89148 3.55662 1.89606 3.46945C1.90524 3.38227 1.93736 3.30427 1.99242 3.23544C2.06124 3.15285 2.13695 3.10238 2.21954 3.08403C2.30672 3.06109 2.39848 3.06797 2.49484 3.10468L3.22437 3.39374C3.34367 3.28821 3.46755 3.18268 3.59603 3.07715C3.7245 2.96703 3.85297 2.86379 3.98144 2.76744L3.83003 1.99661C3.80709 1.89566 3.81167 1.8039 3.84379 1.72131C3.87591 1.63872 3.93097 1.57678 4.00897 1.53548C4.10074 1.48501 4.19021 1.46666 4.27739 1.48042C4.36915 1.4896 4.45174 1.5286 4.52515 1.59742L5.11016 2.10672C5.26616 2.04708 5.41987 1.98972 5.57128 1.93466C5.72729 1.87502 5.88558 1.82225 6.04617 1.77637L6.17006 0.99177C6.18841 0.895416 6.22511 0.815121 6.28017 0.750885C6.33982 0.686649 6.41553 0.645354 6.50729 0.627001C6.60365 0.608648 6.69083 0.620119 6.76883 0.661413C6.84683 0.698119 6.90648 0.755473 6.94777 0.833474L7.3263 1.55613C7.41348 1.54695 7.49607 1.54236 7.57407 1.54236C7.65666 1.53778 7.74154 1.53548 7.82872 1.53548C7.91131 1.53548 7.9939 1.53778 8.07649 1.54236C8.15908 1.54236 8.24167 1.54695 8.32426 1.55613L8.70967 0.833474C8.74638 0.755473 8.80373 0.698119 8.88173 0.661413C8.96432 0.620119 9.0538 0.608648 9.15015 0.627001C9.24192 0.645354 9.31762 0.686649 9.37727 0.750885C9.44151 0.815121 9.47821 0.895416 9.48739 0.99177L9.61127 1.78325C9.76727 1.82454 9.92328 1.87502 10.0793 1.93466C10.2353 1.98972 10.389 2.04708 10.5404 2.10672L11.1323 1.59054C11.2011 1.52631 11.2791 1.4896 11.3663 1.48042C11.4581 1.46666 11.5498 1.48501 11.6416 1.53548C11.7196 1.57678 11.7747 1.63872 11.8068 1.72131C11.8435 1.8039 11.8504 1.89566 11.8274 1.99661L11.6691 2.76744C11.7976 2.86379 11.9261 2.96703 12.0545 3.07715C12.1876 3.18268 12.3115 3.28821 12.4262 3.39374L13.1626 3.10468C13.2544 3.06797 13.3438 3.06109 13.431 3.08403C13.5182 3.10238 13.5962 3.15285 13.665 3.23544C13.7201 3.30427 13.7499 3.38227 13.7545 3.46945C13.7637 3.55662 13.743 3.63921 13.6926 3.71721L13.2727 4.39857C13.4517 4.67387 13.6168 4.96293 13.7683 5.26576L14.5666 5.24511C14.6584 5.23594 14.7433 5.25658 14.8213 5.30706C14.8993 5.35294 14.952 5.42406 14.9796 5.52041C15.0117 5.60759 15.0117 5.69247 14.9796 5.77506C14.952 5.85765 14.9039 5.92647 14.835 5.98153L14.2156 6.48395C14.2569 6.64454 14.2913 6.80743 14.3189 6.9726C14.3464 7.13319 14.367 7.30067 14.3808 7.47502L15.131 7.71591C15.342 7.78473 15.4476 7.91779 15.4476 8.11509C15.4476 8.31239 15.342 8.44545 15.131 8.51427L14.3808 8.75515C14.367 8.92951 14.3464 9.09928 14.3189 9.26446C14.2913 9.42505 14.2569 9.58564 14.2156 9.74623L14.835 10.2418C14.9039 10.3014 14.952 10.3748 14.9796 10.462C15.0117 10.5446 15.0117 10.6295 14.9796 10.7166C14.952 10.813 14.8993 10.8864 14.8213 10.9369C14.7433 10.9828 14.6584 11.0011 14.5666 10.9919L13.7683 10.9644C13.6903 11.1158 13.61 11.2649 13.5274 11.4118C13.4494 11.554 13.3645 11.6917 13.2727 11.8247L13.6926 12.5061C13.743 12.5887 13.7637 12.6758 13.7545 12.7676C13.7499 12.8548 13.7201 12.9328 13.665 13.0016C13.5962 13.0842 13.5182 13.137 13.431 13.1599C13.3438 13.1829 13.2521 13.1737 13.1557 13.1324L12.4262 12.8296C12.3115 12.9443 12.1876 13.0544 12.0545 13.1599C11.9261 13.2654 11.7976 13.3664 11.6691 13.4627L11.8274 14.2405C11.8825 14.4423 11.8205 14.596 11.6416 14.7016C11.5498 14.752 11.4581 14.7704 11.3663 14.7566C11.2791 14.7429 11.2011 14.7039 11.1323 14.6396L10.5404 14.1166C10.389 14.1808 10.2353 14.2405 10.0793 14.2955C9.92328 14.3552 9.76727 14.4056 9.61127 14.4469L9.48739 15.2453C9.47821 15.3416 9.44151 15.4219 9.37727 15.4862C9.31762 15.5504 9.24192 15.5917 9.15015 15.6101C9.0538 15.6284 8.96662 15.6169 8.88862 15.5756C8.81062 15.5389 8.75097 15.4793 8.70967 15.3967L8.32426 14.674C8.24167 14.6832 8.15908 14.6878 8.07649 14.6878C7.9939 14.6924 7.91131 14.6947 7.82872 14.6947ZM7.82872 13.5866C8.59497 13.5866 9.30615 13.4467 9.96228 13.1668C10.6184 12.8869 11.1919 12.4969 11.6829 11.9968C12.1738 11.4967 12.5547 10.9162 12.8254 10.2555C13.1007 9.59481 13.2383 8.88363 13.2383 8.12197C13.2383 7.36032 13.1007 6.64913 12.8254 5.98842C12.5547 5.32311 12.1738 4.7404 11.6829 4.24028C11.1919 3.74016 10.6184 3.35015 9.96228 3.07027C9.30615 2.78579 8.59497 2.64355 7.82872 2.64355C7.06707 2.64355 6.35818 2.78579 5.70205 3.07027C5.04592 3.35015 4.47239 3.74016 3.98144 4.24028C3.49508 4.7404 3.11425 5.32311 2.83896 5.98842C2.56825 6.64913 2.43289 7.36032 2.43289 8.12197C2.43289 8.88363 2.56825 9.59481 2.83896 10.2555C3.11425 10.9162 3.49508 11.4967 3.98144 11.9968C4.47239 12.4969 5.04592 12.8869 5.70205 13.1668C6.35818 13.4467 7.06707 13.5866 7.82872 13.5866ZM6.63118 7.06208L4.29803 3.07715L5.14457 2.60226L7.44331 6.54589L6.63118 7.06208ZM9.3635 8.58309V7.63332H13.9403V8.58309H9.3635ZM7.45707 9.70493L5.06887 13.6279L4.22921 13.1324L6.65183 9.18187L7.45707 9.70493ZM7.81496 9.92517C7.48001 9.92517 7.17718 9.84487 6.90648 9.68428C6.63577 9.52369 6.42012 9.30804 6.25953 9.03733C6.09894 8.76204 6.01864 8.45921 6.01864 8.12885C6.01864 7.79391 6.09894 7.49108 6.25953 7.22037C6.42012 6.94966 6.63577 6.73401 6.90648 6.57342C7.17718 6.40825 7.48001 6.32566 7.81496 6.32566C8.14531 6.32566 8.44585 6.40825 8.71656 6.57342C8.99185 6.73401 9.2098 6.94966 9.37039 7.22037C9.53557 7.49108 9.61815 7.79391 9.61815 8.12885C9.61815 8.45921 9.53557 8.76204 9.37039 9.03733C9.2098 9.30804 8.99185 9.52369 8.71656 9.68428C8.44585 9.84487 8.14531 9.92517 7.81496 9.92517ZM7.81496 8.8928C8.0352 8.8928 8.21873 8.82169 8.36555 8.67945C8.51697 8.53262 8.59267 8.34909 8.59267 8.12885C8.59267 7.90862 8.51697 7.72508 8.36555 7.57826C8.21873 7.42685 8.0352 7.35114 7.81496 7.35114C7.59931 7.35114 7.41578 7.42685 7.26436 7.57826C7.11754 7.72508 7.04412 7.90862 7.04412 8.12885C7.04412 8.34909 7.11754 8.53262 7.26436 8.67945C7.41578 8.82169 7.59931 8.8928 7.81496 8.8928Z" fill="var(--g2)"/></svg></td> -->
              <td class="cc click pointer t2" @click="dict.delete(item.id)">Delete</td>
            </tr>
          </tbody>
          </table>
          <br>
          <p class="tag"  @click="moreBrands()">Load more...</p>
          <br>
        </div>
          <!-- <div class="row">
            <p class="tag" @click="showAdd = true">+Add {{currendDict ? currendDict.title.toLowerCase() : 'brands'}}</p>
          </div> -->


      </Block>

      <!-- models -->
      <Block v-if="brand" style="margin-left: 30px; border-left: 1px solid var(--g05); padding: 0 30px;">

  <Title title="Add a models" plus @plus="showCreateModels = true">{{brand.title}} <template #desc>Create a model for brands. You could edit models right here</template></Title>

  <!-- <p class="tag" @click="showCreateModels = true">+Add models</p> -->
  <!-- <div class="column" style="width: 100%;"> -->
    <div class="column" style="height: 100%; overflow-y: scroll;">

    <!-- <p class="mini">{{brand.id}}</p> -->
    <!-- <h1 contenteditable="true" class="hover" @blur="dict.update(brand.id, 'title', $event.target.innerText)">{{ brand.title }}</h1> -->
    <!-- <p class="mini w350">Upload .SVG or high quality .PNG with transparency. Image must look good on white and on black canvas!</p> -->

    <!-- <br>
    <div class="column center" v-upload="upload" style="height: 200px; width: 200px; border-radius: 20px;" :style="{border: brand.image ? 'none' : '1px solid var(--g2)'}">
        <img v-if="brand.image" :src="brand.image" style="max-height: 200px; max-width: 200px;">
        <div title="Upload brand logo" v-if="!brand.image"><svg width="40" height="31" viewBox="0 0 40 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38.702 25.605C38.702 26.9866 38.3547 28.0656 37.6601 28.842C36.9769 29.6298 35.8952 30.0238 34.415 30.0238H4.83348C3.60376 30.0238 2.69855 29.6812 2.11785 28.9961C1.54853 28.3225 1.20695 27.2663 1.09308 25.8276L7.5491 19.8845C7.89069 19.5534 8.23797 19.3079 8.59095 19.1481C8.95531 18.9882 9.34244 18.9083 9.75235 18.9083C10.1736 18.9083 10.5722 18.9939 10.9479 19.1652C11.335 19.3365 11.7108 19.582 12.0751 19.9017L15.2861 22.8646L23.0572 15.8939C23.4671 15.54 23.8827 15.2716 24.304 15.0889C24.7253 14.9063 25.1751 14.8149 25.6533 14.8149C26.1543 14.8149 26.6211 14.912 27.0538 15.1061C27.4979 15.2888 27.9192 15.5628 28.3177 15.9282L38.702 25.605ZM12.5534 15.7569C11.8133 15.7569 11.1358 15.5799 10.5209 15.226C9.91745 14.8606 9.43353 14.3696 9.06917 13.753C8.70481 13.1365 8.52263 12.4571 8.52263 11.7149C8.52263 10.9842 8.70481 10.3105 9.06917 9.69392C9.43353 9.07735 9.91745 8.58637 10.5209 8.22099C11.1358 7.85562 11.8133 7.67293 12.5534 7.67293C13.2935 7.67293 13.9653 7.85562 14.5687 8.22099C15.1722 8.58637 15.6561 9.07735 16.0205 9.69392C16.3849 10.3105 16.567 10.9842 16.567 11.7149C16.567 12.4571 16.3849 13.1365 16.0205 13.753C15.6561 14.3696 15.1722 14.8606 14.5687 15.226C13.9653 15.5799 13.2935 15.7569 12.5534 15.7569ZM5.02135 31C3.35895 31 2.10646 30.5775 1.26388 29.7326C0.421292 28.8991 0 27.6602 0 26.016V5.0011C0 3.34549 0.421292 2.10092 1.26388 1.2674C2.10646 0.422468 3.35895 0 5.02135 0H34.9616C36.6354 0 37.8935 0.428177 38.7361 1.28453C39.5787 2.12947 40 3.36832 40 5.0011V26.016C40 27.6602 39.5787 28.8991 38.7361 29.7326C37.8935 30.5775 36.6354 31 34.9616 31H5.02135ZM5.07259 28.8934H34.9274C35.8725 28.8934 36.6012 28.6422 37.1136 28.1398C37.626 27.6374 37.8822 26.8895 37.8822 25.8961V5.12099C37.8822 4.12762 37.626 3.37974 37.1136 2.87735C36.6012 2.36354 35.8725 2.10663 34.9274 2.10663H5.07259C4.10475 2.10663 3.36465 2.36354 2.85226 2.87735C2.35127 3.37974 2.10077 4.12762 2.10077 5.12099V25.8961C2.10077 26.8895 2.35127 27.6374 2.85226 28.1398C3.36465 28.6422 4.10475 28.8934 5.07259 28.8934Z" fill="var(--g2)"/></svg></div>
    </div>


    <br> -->

    <!-- <Title plus @plus="showCreateModels = true">Models<template #desc>Custom attributes for {{ cat.title }}. This attributes will be show user when he will add the asset.</template></Title>   -->

    <!-- <div class="row">
      <p class="tag" @click="showCreateModels = true">+Add models</p>
    </div> -->

    <table v-if="models.length" style="margin-bottom: 10px;">
            <tr class="bold">
              <td>ID</td>
              <td>Image</td>
              <td>Active</td>
              <td>GPT</td>
              <td>Title</td>
              <td>Models</td>
              <!-- <td></td> -->
            </tr>
            <tr class="hover" v-for="(item, index) in models" :key="index" :class="{active: model ? item.id == model.id :  false}">
              <td class="t2">{{ item.id }}</td>

              <td class="cc" style="text-align: center;" @click="uploadItem = item" v-upload.images="upload">
                <div class="column center">
                  <img v-if="item.image" :src="item.image" style="max-height: 20px; max-width: 20px;">
                  <div title="Upload brand logo" v-if="!item.image"><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2093 12.0118C18.2093 12.6599 18.0459 13.1661 17.7191 13.5304C17.3977 13.9 16.8887 14.0848 16.1923 14.0848H2.27415C1.69557 14.0848 1.26967 13.9241 0.996447 13.6027C0.728585 13.2866 0.567868 12.7912 0.514295 12.1163L3.55185 9.32823C3.71257 9.1729 3.87597 9.05773 4.04204 8.98274C4.21347 8.90775 4.39562 8.87026 4.58848 8.87026C4.7867 8.87026 4.9742 8.91043 5.15099 8.99078C5.33314 9.07113 5.50993 9.18629 5.68136 9.33627L7.1921 10.7263L10.8484 7.45616C11.0413 7.29011 11.2368 7.16423 11.435 7.07853C11.6333 6.99283 11.8449 6.94998 12.0699 6.94998C12.3056 6.94998 12.5252 6.99551 12.7288 7.08657C12.9377 7.17227 13.136 7.30082 13.3235 7.47223L18.2093 12.0118ZM5.90636 7.39188C5.55814 7.39188 5.23939 7.30886 4.95009 7.14281C4.66616 6.9714 4.43848 6.74108 4.26705 6.45183C4.09561 6.16258 4.0099 5.84387 4.0099 5.4957C4.0099 5.15289 4.09561 4.83686 4.26705 4.54761C4.43848 4.25837 4.66616 4.02804 4.95009 3.85663C5.23939 3.68523 5.55814 3.59953 5.90636 3.59953C6.25458 3.59953 6.57066 3.68523 6.85459 3.85663C7.13853 4.02804 7.36621 4.25837 7.53764 4.54761C7.70907 4.83686 7.79479 5.15289 7.79479 5.4957C7.79479 5.84387 7.70907 6.16258 7.53764 6.45183C7.36621 6.74108 7.13853 6.9714 6.85459 7.14281C6.57066 7.30886 6.25458 7.39188 5.90636 7.39188ZM2.36254 14.5427C1.58039 14.5427 0.99109 14.3445 0.594654 13.9482C0.198218 13.5571 0 12.976 0 12.2046V2.34612C0 1.56944 0.198218 0.985584 0.594654 0.594564C0.99109 0.198188 1.58039 0 2.36254 0H16.4494C17.2369 0 17.8289 0.200866 18.2253 0.602599C18.6218 0.998975 18.82 1.58015 18.82 2.34612V12.2046C18.82 12.976 18.6218 13.5571 18.2253 13.9482C17.8289 14.3445 17.2369 14.5427 16.4494 14.5427H2.36254ZM2.38665 13.5545H16.4333C16.878 13.5545 17.2209 13.4366 17.4619 13.2009C17.703 12.9653 17.8236 12.6144 17.8236 12.1484V2.40236C17.8236 1.93635 17.703 1.58551 17.4619 1.34982C17.2209 1.10878 16.878 0.988263 16.4333 0.988263H2.38665C1.93129 0.988263 1.58307 1.10878 1.34199 1.34982C1.10627 1.58551 0.988412 1.93635 0.988412 2.40236V12.1484C0.988412 12.6144 1.10627 12.9653 1.34199 13.2009C1.58307 13.4366 1.93129 13.5545 2.38665 13.5545Z" fill="var(--g1)"/></svg></div>
                </div>
                <!-- <div v-if="item.image" class="column center" :style="{background: `url(${item.image}) no-repeat center center`}" style="width: 30px;height: 30px; margin: 0px; background-color: 'white'; border-radius: 10px; background-size: contain;" ></div>  -->
                <!-- <div v-if="!item.image" class="column center" style="width: 30px;height: 30px; margin: 0px; background-color: var(--g05); border-radius: 10px; background-size: contain;" ></div>  -->
              </td>

              <td class="cc"><Check small v-model="item.active" @update="dict.update(item.id, 'active', item.active)"/></td>
              <td class="cc"><Check small v-model="item.gpt" @update="dict.update(item.id, 'gpt', item.gpt)"/></td>

              <!-- <td>
                <div v-if="item.image" class="column center" :style="{background: `url(${item.image}) no-repeat center center`}" style="width: 30px;height: 30px; margin: 4px; background-color: 'white'; border-radius: 10px; background-size: contain;" ></div>
                <div v-else @click="brand = item; showUploadBrandLogo = true" class="column center" style="width: 30px;height: 30px; margin: 4px; background-color: var(--g05); border-radius: 10px; background-size: contain;" ></div>
              </td> -->

              <td class="hover"><input class="tableInput" placeholder="title..." type="text" v-model="item.title" @blur="dict.update(item.id, 'title', item.title)"></td>
              <td @click="model = item" :class="{t2: !dict.submodels(item.id).length}" class="cc">{{ dict.submodels(item.id).length || '...' }}</td>
              <td class="cc click pointer t2" @click="dict.delete(item.id)">Delete</td>
            </tr>
          </table>
          <br>
          <p class="tag" @click="moreModels()">Load more...</p>
          <br>

        </div>

      </Block>

      <!-- submodels -->
      <Block v-if="model" style="margin-left: 30px; border-left: 1px solid var(--g05); padding: 0 30px;">

      <Title title="Add a models" plus @plus="showCreateSubModels = true">{{model.title}} <template #desc>Create a model for brands. You could edit models right here</template></Title>

      <!-- <p class="tag" @click="showCreateModels = true">+Add models</p> -->
      <!-- <div class="column" style="width: 100%;"> -->
      <div class="column" style="height: 100%; overflow-y: scroll;">

    <!-- <p class="mini">{{brand.id}}</p> -->
    <!-- <h1 contenteditable="true" class="hover" @blur="dict.update(brand.id, 'title', $event.target.innerText)">{{ brand.title }}</h1> -->
    <!-- <p class="mini w350">Upload .SVG or high quality .PNG with transparency. Image must look good on white and on black canvas!</p> -->

    <!-- <br>
    <div class="column center" v-upload="upload" style="height: 200px; width: 200px; border-radius: 20px;" :style="{border: brand.image ? 'none' : '1px solid var(--g2)'}">
        <img v-if="brand.image" :src="brand.image" style="max-height: 200px; max-width: 200px;">
        <div title="Upload brand logo" v-if="!brand.image"><svg width="40" height="31" viewBox="0 0 40 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38.702 25.605C38.702 26.9866 38.3547 28.0656 37.6601 28.842C36.9769 29.6298 35.8952 30.0238 34.415 30.0238H4.83348C3.60376 30.0238 2.69855 29.6812 2.11785 28.9961C1.54853 28.3225 1.20695 27.2663 1.09308 25.8276L7.5491 19.8845C7.89069 19.5534 8.23797 19.3079 8.59095 19.1481C8.95531 18.9882 9.34244 18.9083 9.75235 18.9083C10.1736 18.9083 10.5722 18.9939 10.9479 19.1652C11.335 19.3365 11.7108 19.582 12.0751 19.9017L15.2861 22.8646L23.0572 15.8939C23.4671 15.54 23.8827 15.2716 24.304 15.0889C24.7253 14.9063 25.1751 14.8149 25.6533 14.8149C26.1543 14.8149 26.6211 14.912 27.0538 15.1061C27.4979 15.2888 27.9192 15.5628 28.3177 15.9282L38.702 25.605ZM12.5534 15.7569C11.8133 15.7569 11.1358 15.5799 10.5209 15.226C9.91745 14.8606 9.43353 14.3696 9.06917 13.753C8.70481 13.1365 8.52263 12.4571 8.52263 11.7149C8.52263 10.9842 8.70481 10.3105 9.06917 9.69392C9.43353 9.07735 9.91745 8.58637 10.5209 8.22099C11.1358 7.85562 11.8133 7.67293 12.5534 7.67293C13.2935 7.67293 13.9653 7.85562 14.5687 8.22099C15.1722 8.58637 15.6561 9.07735 16.0205 9.69392C16.3849 10.3105 16.567 10.9842 16.567 11.7149C16.567 12.4571 16.3849 13.1365 16.0205 13.753C15.6561 14.3696 15.1722 14.8606 14.5687 15.226C13.9653 15.5799 13.2935 15.7569 12.5534 15.7569ZM5.02135 31C3.35895 31 2.10646 30.5775 1.26388 29.7326C0.421292 28.8991 0 27.6602 0 26.016V5.0011C0 3.34549 0.421292 2.10092 1.26388 1.2674C2.10646 0.422468 3.35895 0 5.02135 0H34.9616C36.6354 0 37.8935 0.428177 38.7361 1.28453C39.5787 2.12947 40 3.36832 40 5.0011V26.016C40 27.6602 39.5787 28.8991 38.7361 29.7326C37.8935 30.5775 36.6354 31 34.9616 31H5.02135ZM5.07259 28.8934H34.9274C35.8725 28.8934 36.6012 28.6422 37.1136 28.1398C37.626 27.6374 37.8822 26.8895 37.8822 25.8961V5.12099C37.8822 4.12762 37.626 3.37974 37.1136 2.87735C36.6012 2.36354 35.8725 2.10663 34.9274 2.10663H5.07259C4.10475 2.10663 3.36465 2.36354 2.85226 2.87735C2.35127 3.37974 2.10077 4.12762 2.10077 5.12099V25.8961C2.10077 26.8895 2.35127 27.6374 2.85226 28.1398C3.36465 28.6422 4.10475 28.8934 5.07259 28.8934Z" fill="var(--g2)"/></svg></div>
    </div>


    <br> -->

    <!-- <Title plus @plus="showCreateModels = true">Models<template #desc>Custom attributes for {{ cat.title }}. This attributes will be show user when he will add the asset.</template></Title>   -->

    <!-- <div class="row">
      <p class="tag" @click="showCreateModels = true">+Add models</p>
    </div> -->

    <table v-if="submodels.length" style="margin-bottom: 10px;">
            <tr class="bold">
              <td>ID</td>
              <td>Image</td>
              <td>Active</td>
              <td>GPT</td>
              <td>Title</td>
              <td>Models</td>
              <!-- <td></td> -->
            </tr>
            <tr class="hover" v-for="(item, index) in submodels" :key="index">
              <td class="t2">{{ item.id }}</td>

              <td class="cc" style="text-align: center;" @click="uploadItem = item" v-upload.images="upload">
                <div class="column center">
                  <img v-if="item.image" :src="item.image" style="max-height: 20px; max-width: 20px;">
                  <div title="Upload brand logo" v-if="!item.image"><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2093 12.0118C18.2093 12.6599 18.0459 13.1661 17.7191 13.5304C17.3977 13.9 16.8887 14.0848 16.1923 14.0848H2.27415C1.69557 14.0848 1.26967 13.9241 0.996447 13.6027C0.728585 13.2866 0.567868 12.7912 0.514295 12.1163L3.55185 9.32823C3.71257 9.1729 3.87597 9.05773 4.04204 8.98274C4.21347 8.90775 4.39562 8.87026 4.58848 8.87026C4.7867 8.87026 4.9742 8.91043 5.15099 8.99078C5.33314 9.07113 5.50993 9.18629 5.68136 9.33627L7.1921 10.7263L10.8484 7.45616C11.0413 7.29011 11.2368 7.16423 11.435 7.07853C11.6333 6.99283 11.8449 6.94998 12.0699 6.94998C12.3056 6.94998 12.5252 6.99551 12.7288 7.08657C12.9377 7.17227 13.136 7.30082 13.3235 7.47223L18.2093 12.0118ZM5.90636 7.39188C5.55814 7.39188 5.23939 7.30886 4.95009 7.14281C4.66616 6.9714 4.43848 6.74108 4.26705 6.45183C4.09561 6.16258 4.0099 5.84387 4.0099 5.4957C4.0099 5.15289 4.09561 4.83686 4.26705 4.54761C4.43848 4.25837 4.66616 4.02804 4.95009 3.85663C5.23939 3.68523 5.55814 3.59953 5.90636 3.59953C6.25458 3.59953 6.57066 3.68523 6.85459 3.85663C7.13853 4.02804 7.36621 4.25837 7.53764 4.54761C7.70907 4.83686 7.79479 5.15289 7.79479 5.4957C7.79479 5.84387 7.70907 6.16258 7.53764 6.45183C7.36621 6.74108 7.13853 6.9714 6.85459 7.14281C6.57066 7.30886 6.25458 7.39188 5.90636 7.39188ZM2.36254 14.5427C1.58039 14.5427 0.99109 14.3445 0.594654 13.9482C0.198218 13.5571 0 12.976 0 12.2046V2.34612C0 1.56944 0.198218 0.985584 0.594654 0.594564C0.99109 0.198188 1.58039 0 2.36254 0H16.4494C17.2369 0 17.8289 0.200866 18.2253 0.602599C18.6218 0.998975 18.82 1.58015 18.82 2.34612V12.2046C18.82 12.976 18.6218 13.5571 18.2253 13.9482C17.8289 14.3445 17.2369 14.5427 16.4494 14.5427H2.36254ZM2.38665 13.5545H16.4333C16.878 13.5545 17.2209 13.4366 17.4619 13.2009C17.703 12.9653 17.8236 12.6144 17.8236 12.1484V2.40236C17.8236 1.93635 17.703 1.58551 17.4619 1.34982C17.2209 1.10878 16.878 0.988263 16.4333 0.988263H2.38665C1.93129 0.988263 1.58307 1.10878 1.34199 1.34982C1.10627 1.58551 0.988412 1.93635 0.988412 2.40236V12.1484C0.988412 12.6144 1.10627 12.9653 1.34199 13.2009C1.58307 13.4366 1.93129 13.5545 2.38665 13.5545Z" fill="var(--g1)"/></svg></div>
                </div>
                <!-- <div v-if="item.image" class="column center" :style="{background: `url(${item.image}) no-repeat center center`}" style="width: 30px;height: 30px; margin: 0px; background-color: 'white'; border-radius: 10px; background-size: contain;" ></div>  -->
                <!-- <div v-if="!item.image" class="column center" style="width: 30px;height: 30px; margin: 0px; background-color: var(--g05); border-radius: 10px; background-size: contain;" ></div>  -->
              </td>

              <td class="cc"><Check small v-model="item.active" @update="dict.update(item.id, 'active', item.active)"/></td>
              <td class="cc"><Check small v-model="item.gpt" @update="dict.update(item.id, 'gpt', item.gpt)"/></td>

              <!-- <td>
                <div v-if="item.image" class="column center" :style="{background: `url(${item.image}) no-repeat center center`}" style="width: 30px;height: 30px; margin: 4px; background-color: 'white'; border-radius: 10px; background-size: contain;" ></div>
                <div v-else @click="brand = item; showUploadBrandLogo = true" class="column center" style="width: 30px;height: 30px; margin: 4px; background-color: var(--g05); border-radius: 10px; background-size: contain;" ></div>
              </td> -->

              <td class="hover"><input class="tableInput" placeholder="title..." type="text" v-model="item.title" @blur="dict.update(item.id, 'title', item.title)"></td>
              <td class="cc click pointer t2" @click="dict.delete(item.id)">Delete</td>
            </tr>
          </table>
        </div>

      </Block>

  </div>



  <!-- create brands -->
  <Popup v-model="showAdd" plus :progress="progress" :up="name" :title="`Add ${name}`"  line="Add models each on new line">
      <div class="column w400">
        <textarea v-model="list" class="w400" style="height: 50vh;" placeholder="Write list each on new line"></textarea>
        <div class="row center padding">
          <p class="button margin" @click="createBrands()">Add brands</p>
          <p class="button margin" @click="showAdd = false">Cancel</p>
        </div>
      </div>
  </Popup>

  <!-- create models -->
  <Popup v-model="showCreateModels" plus :progress="progress" :title="`${brand ? brand.title :''}`" line="Add models each on new line">
      <div class="column w400">
        <textarea v-model="list" class="w400" style="height: 50vh;" :placeholder="`Paint\nPhoto\nSculpture\netc...`"></textarea>
        <div class="row center padding">
          <p class="button margin" @click="createModels()">Add models</p>
          <p class="button margin" @click="showCreateModels = false">Cancel</p>
        </div>
      </div>
  </Popup>

  <!-- create submodels -->
  <Popup v-model="showCreateSubModels" plus  :progress="progress" :title="`${model ? model.title :''}`" line="Write list each on new line">
      <div class="column w400">
        <textarea v-model="list" class="w400" style="height: 50vh;" :placeholder="`Paint\nPhoto\nSculpture\netc...`"></textarea>
        <div class="row center padding">
          <p class="button margin" @click="dict.create(model.id, 'submodels', list); showCreateSubModels =false">Add submodels</p>
          <p class="button margin" @click="showCreateSubModels = false">Cancel</p>
        </div>
      </div>
  </Popup>

  <!-- upload brand logo uploadItem = brand/dict -->
  <Popup v-model="uploadItem">
    <div class="column w300 center" v-if="uploading">
      <Loader width="100px" color="#A3568F" borders="4px solid #0000"/>
    </div>

    <div v-else class="column w300 center">
        <p class="mini">Check</p>
      <h4>Preview</h4>
      <p class="mini w250 mb2">Upload .SVG or high quality .PNG with transparency. Image must look good on white and on black canvas!</p>

      <div class="row mt2 mb4">
        <p class="tab" @click="dark = true" :class="{active: dark}">Dark</p>
        <p class="tab" @click="dark = false" :class="{active: !dark}">Light</p>
        <!-- <p cla :id="true" v-model="dark">Dark</p> -->
        <!-- <Tag :id="false" v-model="dark">Light</Tag> -->
      </div>

      <div class="column center" style="padding: 20px;" :style="{background: dark ? 'black' : 'white'}">
        <div v-if="image" class="column center click pointer" :style="{background: `url(${image}) no-repeat center center`}" style="width: 200px;height: 200px; margin: 4px; background-color: 'white'; border-radius: 10px; background-size: contain;" ></div>
        <div v-else  class="column center click pointer" style="width: 200px;height: 200px; margin: 4px; background-color: var(--g05); border-radius: 10px; background-size: contain;" >

        </div>

        <!-- <svg width="44" height="34" viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.5722 28.0829C42.5722 29.5982 42.1902 30.7816 41.4261 31.6331C40.6746 32.4972 39.4848 32.9293 37.8565 32.9293H5.31682C3.96413 32.9293 2.9684 32.5536 2.32963 31.8022C1.70339 31.0634 1.32764 29.905 1.20239 28.3271L8.30401 21.8088C8.67976 21.4457 9.06177 21.1764 9.45004 21.0011C9.85084 20.8258 10.2767 20.7381 10.7276 20.7381C11.191 20.7381 11.6294 20.832 12.0427 21.0199C12.4685 21.2077 12.8819 21.477 13.2827 21.8276L16.8147 25.0773L25.3629 17.432C25.8138 17.0438 26.271 16.7495 26.7344 16.5492C27.1978 16.3488 27.6926 16.2486 28.2186 16.2486C28.7697 16.2486 29.2832 16.3551 29.7592 16.568C30.2477 16.7683 30.7111 17.0689 31.1494 17.4696L42.5722 28.0829ZM13.8087 17.2818C12.9946 17.2818 12.2494 17.0877 11.573 16.6994C10.9092 16.2987 10.3769 15.7602 9.97609 15.084C9.57529 14.4077 9.37489 13.6626 9.37489 12.8486C9.37489 12.0471 9.57529 11.3083 9.97609 10.632C10.3769 9.9558 10.9092 9.41731 11.573 9.01657C12.2494 8.61584 12.9946 8.41547 13.8087 8.41547C14.6228 8.41547 15.3618 8.61584 16.0256 9.01657C16.6894 9.41731 17.2217 9.9558 17.6225 10.632C18.0233 11.3083 18.2237 12.0471 18.2237 12.8486C18.2237 13.6626 18.0233 14.4077 17.6225 15.084C17.2217 15.7602 16.6894 16.2987 16.0256 16.6994C15.3618 17.0877 14.6228 17.2818 13.8087 17.2818ZM5.52348 34C3.69485 34 2.31711 33.5366 1.39026 32.6099C0.463422 31.6958 0 30.337 0 28.5337V5.48508C0 3.66924 0.463422 2.30424 1.39026 1.39006C2.31711 0.463352 3.69485 0 5.52348 0H38.4577C40.2989 0 41.6829 0.469613 42.6097 1.40884C43.5366 2.33554 44 3.69429 44 5.48508V28.5337C44 30.337 43.5366 31.6958 42.6097 32.6099C41.6829 33.5366 40.2989 34 38.4577 34H5.52348ZM5.57985 31.6895H38.4202C39.4597 31.6895 40.2613 31.414 40.8249 30.863C41.3886 30.312 41.6704 29.4917 41.6704 28.4022V5.61657C41.6704 4.52707 41.3886 3.70681 40.8249 3.1558C40.2613 2.59227 39.4597 2.3105 38.4202 2.3105H5.57985C4.51523 2.3105 3.70111 2.59227 3.13749 3.1558C2.58639 3.70681 2.31085 4.52707 2.31085 5.61657V28.4022C2.31085 29.4917 2.58639 30.312 3.13749 30.863C3.70111 31.414 4.51523 31.6895 5.57985 31.6895Z" fill="white" fill-opacity="0.6"/></svg> -->
      </div>
    </div>

      <br>
      <div class="row center">
          <p class="button margin" @click="uploadImage()">OK</p>
          <p class="button margin" @click="image = undefined, uploadItem = undefined">Cancel</p>
        </div>
  </Popup>

  <!-- error -->
  <Popup v-model="error" style="z-index: 1000000;">
      <template #icon><p style="font-size: 60px; line-height: 60px; font-weight: 700;" class="bad">{{ error.code }}</p></template>
      <template #line> #{{ error.id }}</template>
      <div class="column w350">
          <p class="desc" style="font-size: 16px; letter-spacing: 0.02em;">{{ error.explain || error.comment }}</p>
      </div>
      <br>
      <div class="row center">
          <p class="button popupButtonColor" @click="error=undefined">OK</p>
        </div>
      <p class="mini">{{ error.comment }}</p>
  </Popup>





</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  mounted() {

    this.sid = this.$route.params.category
    this.name = this.$route.params.name

  },

  data() {
    return {
      sid: undefined,
      name: undefined,
      showAdd: false,
      showAddAttr: false,
      showCreateModels: false,
      showCreateSubModels: false,
      showEditSub: false,
      showUpload: false,

      progress: false,

      error: undefined,

      notfound: false,

      currendDict: undefined,

      brand: undefined,
      model: undefined,

      uploadItem: undefined,
      uploading: false,
      image: undefined,
      dark: true,
      sub: {},
      list: undefined,

      branditems: [],
      brandLimit: 50,
      brandOffset:0,
      brandLike:'',

      modelsitems: [],
      modelsLimit: 50,
      modelsOffset:0,
    }
  },
  watch: {

    brand(val) {
      this.model = undefined
      this.modelsOffset = 0
      if (val.id) this.getModels()
    },

    cat(val){
      if (val.id) {
        this.brandOffset = 0
        this.getBrands()
      }

    },
  },
  computed: {

      cat(){
        return this.dict.sid(this.sid) || {}
      },

      meta(){
        if (!this.cat || !this.cat.meta) return {}
        return this.cat.meta || {}
      },

      brands(){
        return this.branditems
      },

      models(){
        return this.modelsitems
      },

      // custom dicts
      dicts(){
        if (!this.cat || !this.cat.id) return undefined
        return this.dict.dicts(this.cat.id)
      },


      submodels(){
        if (!this.model) return []
        return this.dict.submodels(this.model.id).sort((a, b) => a.id - b.id) || []
      },

       attr(){
        if (!this.cat) return {}
        // console.log('cat',this.cat)
        let res = this.dict.attr.field(this.cat.id, this.name) || {}
        console.log('dict',res)
        return res
      },
  },
  methods: {

    refresh(){
      this.dict.refresh()
    },

    setBrand(item){
      this.brand = item
      this.modelsitems = []
    },

    brandSearch(e){
      this.brandLimit = 50
      this.brandOffset = 0
      this.brandLike = e.target.value
      this.branditems = []
      this.getBrands()
    },

    async getBrands(){
        let limit = this.brandLimit
        let offset = this.brandOffset
        let like = `${this.brandLike}%`
        let res = await this.api.send('dict/search',{parent: this.cat.id, name:'brands', limit, offset, like})
        if (res.error){
          return []
        }
        this.branditems = res.resp
        // if (brands && brands.length) this.branditems.push(...brands)
    },

    async moreBrands(){
      this.brandOffset = this.brandOffset + this.brandLimit

      let limit = this.brandLimit
      let offset = this.brandOffset
      let like = `${this.brandLike}%`

      let res = await this.api.send('dict/search',{parent: this.cat.id, name:'brands', limit, offset, like})
      if (res.error){
        return []
      }
      let brands = res.resp
      if (brands && brands.length) this.branditems.push(...brands)
    },

    async getModels(){
        if (!this.brand.id) return
        let limit = this.modelsLimit
        let offset = this.modelsOffset
        let res = await this.api.send('dict/search',{parent: this.brand.id, name:'models', limit, offset})
        if (res.error){
          return []
        }
        let models = res.resp
        if (models && models.length) this.modelsitems.push(...models)
    },

    moreModels(){
      this.modelsOffset = this.modelsOffset + this.modelsLimit
      this.getModels()
    },


    async createBrands(){
      if (!this.list) return
      this.progress = true
      let res = await this.dict.create(this.cat.id, 'brands', this.list)
      this.progress = false
      // lazy error
      this.showAdd = false
      this.list = undefined
      this.getBrands()
    },

    async createModels(){
      if (!this.list || !this.brand.id) return
      this.progress = true
      let res = await this.dict.create(this.brand.id, 'models', this.list)
      this.progress = false
      // lazy error
      this.showCreateModels = false
      this.list = undefined
      this.getModels()
    },

    async upload(file){
      console.log(file)
      let logo = file[0]

      let image = await this.tools.readFileAsBase64(logo)
      console.log(image)
      this.image = image
      this.showUpload = true

    },

    async uploadImage(){
      this.uploading = true
      let id = this.uploadItem.id
      let res = await this.api.upload.logo(id, this.image)
      if (res.error){
        this.uploading = false
        console.error(res)
        return
      }
      let link = res.resp.link
      if (!link){
        this.uploading = false
        console.error('empty link')
        return
      }

      console.log('link',link)

      this.dict.update(id, 'image', link)
      this.uploadItem = undefined
      this.uploading = false
    },


  },
});
</script>
<style scoped>
.sticky{
  position: fixed;
  background: var(--back);
  z-index: 24;
}
</style>